var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagnifierTool1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 587.471,
    height: 587.471,
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m220.302,440.604c121.476,0 220.302,-98.826 220.302,-220.302c0,-121.476 -98.827,-220.302 -220.302,-220.302c-121.476,0 -220.302,98.826 -220.302,220.302c0,121.475 98.826,220.302 220.302,220.302zm0,-369.462c82.247,0 149.159,66.913 149.159,149.159c0,82.248 -66.912,149.16 -149.159,149.16s-149.16,-66.912 -149.16,-149.16c0,-82.246 66.913,-149.159 149.16,-149.159z",
    id: "svg_3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m525.523,587.471c16.555,0 32.113,-6.447 43.801,-18.158c11.699,-11.68 18.146,-27.234 18.146,-43.791c0,-16.553 -6.447,-32.115 -18.152,-43.822l-122.675,-122.677c-3.262,-3.262 -7.475,-5.061 -11.859,-5.061c-5.449,0 -10.465,2.711 -13.762,7.438c-16.238,23.318 -36.297,43.377 -59.613,59.615c-4.258,2.965 -6.947,7.467 -7.379,12.352c-0.428,4.828 1.393,9.666 4.998,13.27l122.674,122.676c11.704,11.71 27.267,18.158 43.821,18.158z",
    id: "svg_4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svg_5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_10"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_11"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_13"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_14"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_15"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_16"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_17"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_18"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_19"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifierTool1);
export default __webpack_public_path__ + "static/media/magnifier-tool1.67dbe7541f2c731c3d06321da89fad35.svg";
export { ForwardRef as ReactComponent };